import 'twin.macro';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export function FilterBar(props: Props) {
  const { children } = props;
  const { t } = useTranslation(['common']);
  return (
    <div tw="bg-neutral-quiet rounded-lg mb-2" className={props.className}>
      <div tw="max-w-7xl py-3 px-4 sm:flex sm:items-center sm:px-6">
        <h3 tw="text-xs font-semibold uppercase tracking-wide text-neutral-quiet">
          {t('common:filterBar.title')}
        </h3>

        <div
          aria-hidden="true"
          tw="hidden w-px h-5 bg-neutral-moderate sm:block sm:ml-4"
        />

        <div tw="mt-2 sm:mt-0 sm:ml-4">
          <div tw="-m-1 flex flex-wrap items-center">{children}</div>
        </div>
      </div>
    </div>
  );
}
